import { isOfferItemType } from './isOfferItemType';
const getSelectedItemPrice = (variantId, items) => {
    const itemWithPrice = items.find((item) => 'variantId' in item && item.variantId === variantId);
    if (!itemWithPrice || isOfferItemType(itemWithPrice))
        return undefined;
    return itemWithPrice.price;
};
export const getInitialSelectedItems = (initialValues, items) => initialValues.items.reduce((acc, { variantId, quantity }) => [
    ...acc,
    {
        variantId,
        quantity: quantity.toString(),
        price: getSelectedItemPrice(variantId, items),
    },
], []);
